import React from "react";
import { formatMarathiDate } from "@/lib/documentUtils";
import { T } from "@/context/MarathiEditContext";
import AutoFitLine from "@/components/AutoFitLine";

export const VakalatnamaMarathi = React.forwardRef(function VakalatnamaMarathi({ data }, ref) {
  const {
    caseNo, courtName, courtPlace, party1Name, party2Name, party1Role, party2Role,
    advocateName, advocateMahNumber, advocateCode, advocateAddress,
    advocateMobile, advocateEmail, extraAdvocates = [], date,
    advocateAppearingFor, advocateAppearingNumber,
  } = data;

  const mrDate = formatMarathiDate(date);
  const activeExtras = extraAdvocates.filter((a) => a.name || a.mah || a.code);
  const appearLabel = advocateAppearingFor
    ? `${advocateAppearingFor}${
        advocateAppearingNumber && String(advocateAppearingNumber).trim()
          ? ` No. ${String(advocateAppearingNumber).trim()}`
          : ""
      }`
    : "";

  return (
    <div ref={ref} className="a4-sheet mr-doc vakalat-sheet" data-testid="vakalatnama-mr-doc">
      <div className="welfare-note-vakalat">
        अ‍ॅडव्होकेट अ‍ॅक्ट १९६१ कलम ३४ (१) खालील मुंबई हायकोर्ट अपेलेट साईड रुल्स
        शेडयूल ७/१९८५ प्रमाणे आम्ही महा. अ‍ॅड. वेलफेअर फंडाचा सभासद नाही, त्यासाठी
        वेलफेअर स्टॅम्प रु. २ लावला नाही.
      </div>

      <h1 className="doc-title mr-title">वकील पत्र</h1>

      <div className="memo-case-row">
        <div className="memo-case-spacer" />
        <div className="memo-case-no-right" data-testid="vakalat-mr-case-no">
          <T source={caseNo} placeholder="___________" />
        </div>
      </div>

      <div className="mr-court-block">
        <h2 className="doc-court-heading mr-court-left">
          मे.&nbsp;<T source={courtName} placeholder="________________________" />
          {courtPlace && String(courtPlace).trim() ? (
            <>,&nbsp;<T source={courtPlace} placeholder="___________" /></>
          ) : null}
        </h2>
        <h3 className="doc-court-at mr-court-right-in-block">यांचे कोर्टात...</h3>
      </div>

      <div className="party-block">
        <div className="pb-row">
          <div className="pb-name"><T source={party1Name} placeholder="____________________" /></div>
          <div className="pb-brace">{"}"}</div>
          <div className="pb-role">
            वादी / अर्जदार
            <br />
            अपीलकर्ता / फिर्यादी
          </div>
        </div>
        <div className="pb-vs-row">
          <div className="pb-vs-inner">विरुद्ध</div>
        </div>
        <div className="pb-row">
          <div className="pb-name"><T source={party2Name} placeholder="____________________" /></div>
          <div className="pb-brace">{"}"}</div>
          <div className="pb-role">
            प्रतिवादी / वि.प.
            <br />
            रिस्पॉन्डंट / आरोपी
          </div>
        </div>
      </div>

      <div className="doc-body mr-body">
        <p>
          यातील खालील सही करणार&nbsp;
          <strong><T source={appearLabel} placeholder="प्रतिवादी" /></strong>
          &nbsp;यांनी या लेखावरुन सदरहू केसचे कामी आपलेतर्फे हजर राहून सदर काम चालविणेस
        </p>

        <p className="adv-line">
          अ‍ॅड.&nbsp;<strong><T source={advocateName} placeholder="_________________________" /></strong>
          &nbsp;(MAH – {advocateMahNumber || "________/____"})
          &nbsp;(Code – {advocateCode || "____"})
        </p>

        {activeExtras.map((a, idx) => (
          <p className="adv-line" key={idx}>
            अ‍ॅड.&nbsp;<strong><T source={a.name} placeholder="_____________________" /></strong>
            &nbsp;(MAH – {a.mah || "________/____"})
            &nbsp;(Code – {a.code || "____"})
          </p>
        ))}

        <p>
          यांना आपले तर्फे वकील नेमलेले आहे. याचे साक्षीकरिता आम्ही आपली सही /
          आपल्या सहया स्वतः समक्ष आजरोजी या खाली केली / केल्या आहेत.
        </p>

        <p>तारीख&nbsp;<strong>{mrDate}</strong>&nbsp;इ.</p>
      </div>

      <div className="vakalat-accept-row">
        <div>
          <div className="filed-line">कबूल करुन हजर ता.&nbsp;{mrDate}</div>
          <div className="adv-sig-label">अ‍ॅड.</div>
        </div>
        <div className="signatory-block" data-testid="vakalat-mr-client-signature">
          <div className="sig-line" aria-hidden="true" />
        </div>
      </div>

      <div className="adv-contact-box adv-contact-plain" data-testid="vakalat-mr-advocate-contact">
        <div className="adv-contact-grid">
          <div className="adv-contact-full">
            <span className="adv-info-label">ऑफिस पत्ता :</span>&nbsp;
            <span className="adv-info-value">
              <T source={advocateAddress} placeholder="_______________________________________________" />
            </span>
          </div>
          <AutoFitLine className="adv-contact-full" min={7} gap={16} testId="vakalat-mr-email-mobile-line">
            <span className="adv-em-cell">
              <span className="adv-info-label">ई-मेल-</span>&nbsp;
              <span className="adv-info-value">{advocateEmail || "____________________"}</span>
            </span>
            <span className="adv-em-cell">
              <span className="adv-info-label">मो.नं.</span>&nbsp;
              <span className="adv-info-value">{advocateMobile || "____________"}</span>
            </span>
          </AutoFitLine>
        </div>
      </div>
    </div>
  );
});

export default VakalatnamaMarathi;
